import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/companies/:creatorId/:companyId']['GET'];

type Input = {
  creatorId: string;
  companyId: string;
};

type Output = ThisApi['response'];

const getCompanyById = async ({ creatorId, companyId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/companies/${creatorId}/${companyId}`);

  return response.data;
};

export default getCompanyById;
